import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import Icon from '../../../Icon';
import { i18n } from '@lingui/core';
import { x } from '@xstyled/styled-components';
import { FooterRow } from './FooterRow';
import { FooterRowLabel } from './FooterRowLabel';
import { TimeInput } from './TimeInput';
export var Timepicker = function (_a) {
    var _b, _c, _d, _e;
    var setTime = _a.setTime, value = _a.value, disabled = _a.disabled;
    var initialHours = (_c = (_b = value === null || value === void 0 ? void 0 : value.getHours) === null || _b === void 0 ? void 0 : _b.call(value)) !== null && _c !== void 0 ? _c : 0;
    var initialMinutes = (_e = (_d = value === null || value === void 0 ? void 0 : value.getMinutes) === null || _d === void 0 ? void 0 : _d.call(value)) !== null && _e !== void 0 ? _e : 0;
    var _f = useState(initialHours), hours = _f[0], setHours = _f[1];
    var _g = useState(initialMinutes), minutes = _g[0], setMinutes = _g[1];
    var onChange = useCallback(function (e) {
        var _a = e.target.value.split(':'), hours = _a[0], minutes = _a[1];
        setHours(Number(hours));
        setMinutes(Number(minutes));
    }, []);
    useEffect(function () {
        !!value && setTime('hours', hours);
    }, [hours]);
    useEffect(function () {
        !!value && setTime('minutes', minutes);
    }, [minutes]);
    var timeValue = "".concat((hours).toString().padStart(2, '0'), ":").concat((minutes).toString().padStart(2, '0'));
    return (_jsx(x.div, { borderTop: "1px solid", borderColor: "lightGray2", pt: "8px", mb: "8px", children: _jsxs(FooterRow, { disabled: disabled || !value, children: [_jsxs(x.div, { children: [_jsx(Icon, { icon: "clock" }), _jsx(FooterRowLabel, { children: i18n._({ id: 'dataGrid.filterCell.time', message: 'Time' }) })] }), _jsx(x.div, { display: "flex", alignItems: "center", children: _jsx(TimeInput, { type: "time", onChange: onChange, disabled: disabled || !value, value: timeValue }) })] }) }));
};
